export default __webpack_public_path__ + "assets/insets7.png";